import './Footer.scss';

const year = new Date().getFullYear();

function Footer () {
    return <footer className="site-footer">
        <p>&#169;{year} English Law Corp.</p>
    </footer>
}

export default Footer;